/*
  narin. — motion system (Motion One)
  Editorial-dramatic: hero sequence, scroll reveals, staggered groups,
  parallax. Resilient: falls back to fully-visible content if Motion
  fails to load, JS is off, or the user prefers reduced motion.
*/
(function () {
  // Signals to the inline head safety-net that the motion layer is alive.
  window.__narinMotionReady = true;

  // Single elements that reveal on scroll
  var REVEAL = [
    '[data-reveal]',
    '.rich-text__blocks > *',
    '.image-with-text__text-item > *',
    '.collection-hero > *',
    '.article-template__content > *',
    '.newsletter__wrapper > *'
  ].join(',');

  // Groups whose children reveal with a stagger
  var GROUPS = '.product-grid, .narin-marks__grid, .multicolumn-list, .contact__fields';

  function showAll() {
    document
      .querySelectorAll(REVEAL + ',' + GROUPS + ' > *,[data-hero-el]')
      .forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
  }

  var M = window.Motion;
  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No library, or user opts out → just show everything, no motion.
  if (!M || reduce) {
    showAll();
    return;
  }

  var animate = M.animate,
    inView = M.inView,
    scroll = M.scroll,
    stagger = M.stagger;
  var EASE = [0.16, 1, 0.3, 1]; // expo-out, the "expensive" easing

  // Safety net: if anything is still hidden after 3.5s, force it visible.
  setTimeout(showAll, 3500);

  function run() {
    // ---- Hero load sequence ----
    var hero = document.querySelector('[data-hero]');
    if (hero) {
      var els = hero.querySelectorAll('[data-hero-el]');
      if (els.length) {
        animate(
          els,
          { opacity: [0, 1], transform: ['translateY(42px)', 'translateY(0)'] },
          { delay: stagger(0.12, { startDelay: 0.15 }), duration: 1.2, easing: EASE }
        );
      }
      var media = hero.querySelector('[data-hero-media]');
      if (media && scroll) {
        try {
          scroll(
            animate(media, { transform: ['scale(1.08)', 'scale(1.2)'] }, { easing: 'linear' }),
            { target: hero, offset: ['start start', 'end start'] }
          );
        } catch (e) {}
      }
    }

    // ---- Single-element reveals ----
    inView(
      REVEAL,
      function (info) {
        var el = info.target;
        if (el.__nrev) return;
        el.__nrev = 1;
        animate(
          el,
          { opacity: [0, 1], transform: ['translateY(32px)', 'translateY(0)'] },
          { duration: 0.9, easing: EASE }
        );
      },
      { margin: '0px 0px -8% 0px', amount: 0.15 }
    );

    // ---- Staggered groups ----
    document.querySelectorAll(GROUPS).forEach(function (group) {
      inView(
        group,
        function () {
          if (group.__nrev) return;
          group.__nrev = 1;
          animate(
            group.children,
            { opacity: [0, 1], transform: ['translateY(36px)', 'translateY(0)'] },
            { delay: stagger(0.07), duration: 0.85, easing: EASE }
          );
        },
        { amount: 0.1 }
      );
    });

    // ---- Generic parallax (data-parallax inside data-parallax-root) ----
    document.querySelectorAll('[data-parallax]').forEach(function (el) {
      if (!scroll) return;
      var root = el.closest('[data-parallax-root]') || el.parentElement;
      try {
        scroll(
          animate(el, { transform: ['translateY(-6%)', 'translateY(6%)'] }, { easing: 'linear' }),
          { target: root, offset: ['start end', 'end start'] }
        );
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
